import React from 'react';
import { Button, Loader } from 'react-inv-forms';
import { Tooltip } from 'antd';
import { DownloadOutlined, PrinterOutlined, WarningOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

import { ActionsElements, ButtonWithText } from './PdfActionButtons.style';

export interface Props {
  /** informacja czy plik PDF został poprawnie wygenerowany */
  pdfGenerateStatus: Protocol.IPdfGenerated;
  /** informacja czy trwa proces pobierania pliku */
  downloadInProcess: boolean;
  /** informacja czy trwa proces drukowania pliku */
  printOutInProcess: boolean;
  /** callback wykonywany na przycisku "Pobierz" */
  onDownload: () => void;
  /** callback wykonywany na przycisku "Drukuj" */
  onPrintOut: () => void;
}

/**
 * Komponent zaweirający kontener dla przycisków akcji służących do pobierania / drukowania plików PDF
 *
 */
export const PdfActionButtons = ({
  pdfGenerateStatus,
  downloadInProcess,
  printOutInProcess,
  onDownload,
  onPrintOut,
}: Props): JSX.Element => {
  const { t } = useTranslation();

  const getProtocolErrorTooltipTitle = pdfGenerateStatus.errors.noSignMarks
    ? t('PROTOCOL_NOT_GENERATED_NO_SIGN_MARKS')
    : pdfGenerateStatus.errors.unknown
    ? t('PROTOCOL_NOT_GENERATED_UNKNOWN')
    : undefined;

  const getProtocolErrorButtonErrorText = pdfGenerateStatus.errors.noSignMarks
    ? t('PROTOCOL_NOT_GENERATED_NO_SIGN_MARKS_ERROR_INFO')
    : pdfGenerateStatus.errors.unknown
    ? t('PROTOCOL_NOT_GENERATED_UNKNOWN_ERROR_INFO')
    : undefined;

  return (
    <ActionsElements>
      {pdfGenerateStatus.status ? (
        <>
          <Button
            disabled={!pdfGenerateStatus.status}
            iconButton
            icon={downloadInProcess ? <Loader /> : <DownloadOutlined />}
            onClick={onDownload}
            className='btn_no_hover'
            data-cy='btnPdf'
          />

          <Button
            iconButton
            icon={printOutInProcess ? <Loader /> : <PrinterOutlined />}
            onClick={onPrintOut}
            disabled={!pdfGenerateStatus.status}
            data-cy='btnPrint'
          />
        </>
      ) : (
        <Tooltip title={getProtocolErrorTooltipTitle} placement='left'>
          <ButtonWithText>
            <Button iconButton icon={<WarningOutlined />} data-cy='btnPdfNotGenerated' />
            {pdfGenerateStatus.errors.noSignMarks && <span className='errorText'>{getProtocolErrorButtonErrorText}</span>}
          </ButtonWithText>
        </Tooltip>
      )}
    </ActionsElements>
  );
};

export default PdfActionButtons;
